<template>
  <v-card style="height: 100%">
    <div class="d-chart-card">
      <div class="overflowX-hidden mx-8" style="height: 100%; overflow-y: hidden">
        <v-row no-gutters class="mt-4">
          <v-row no-gutters>
            <!-- :class="{ 'primary--text': newChart.type == chartTypes.liveTable }" -->
            <v-icon x-small class="mr-1 mb-1 primary--text"
            >fas fa-broadcast-tower
            </v-icon
            >
            <!-- :class="{ 'primary--text': newChart.type == chartTypes.liveTable }" -->
            <p class="text-center mb-0 primary--text">Spreads</p>
            <p class="text-center mb-0 mx-1">-</p>
            <p class="text-center mb-0">{{ cardInfo.name }}</p>
          </v-row>
          <v-spacer></v-spacer>

          <v-menu
              v-model="symbolsMenu"
              offset-y
              max-height="350"
              close-on-click
              :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary" small text dark>
                Symbols
              </v-btn>
            </template>
            <div>
              <v-list max-height="250" dense class="overflowY-auto">
                <v-list-item
                    v-for="(item, index) in allSymbols"
                    :key="index"
                    @click="item.selected = !item.selected"
                >
                  <v-list-item-title
                      :class="{ 'primary--text': item.selected }"
                  >{{ item.symbol }}</v-list-item-title
                  >
                </v-list-item>
                <v-list-item v-if="!allSymbols.length" style="font-size: 12px">
                  No symbols available
                </v-list-item>
              </v-list>
              <div
                  @click="updateTableColumns"
                  :style="
                $vuetify.theme.dark ? 'background: #1e1e1e' : 'background: #fff'
              "
              >
                <v-btn
                    text
                    width="100%"
                    small
                    :style="
                  $vuetify.theme.dark
                    ? 'border-top: 1px solid rgb(255, 255, 255, 0.3)'
                    : 'border-top: 1px solid rgb(0, 0, 0, 0.3)'
                "
                >Save</v-btn
                >
              </div>
              <!-- <v-list-item>
                <v-list-item-title>Save</v-list-item-title>
              </v-list-item> -->
            </div>
          </v-menu>

          <v-menu
              v-model="watchersMenu"
              offset-y
              max-height="350"
              close-on-click
              :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary" small text dark>
                Watchers
              </v-btn>
            </template>
            <v-list max-height="250" dense class="overflowY-auto">
              <v-list-item
                  v-for="(item, index) in watchersMenuItems"
                  :key="index"
                  @click="item.selected = !item.selected"
              >
                <v-list-item-title
                    :class="{
                  'primary--text': item.selected,
                  'grey--text': item.appStatus !== 'RUN',
                }"
                >{{ item.name }}</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                  v-if="!watchersMenuItems.length"
                  style="font-size: 12px"
              >
                No watchers available
              </v-list-item>
            </v-list>
            <div
                @click="updateTableRows"
                :style="
              $vuetify.theme.dark ? 'background: #1e1e1e' : 'background: #fff'
            "
            >
              <v-btn
                  text
                  width="100%"
                  small
                  :style="
                $vuetify.theme.dark
                  ? 'border-top: 1px solid rgb(255, 255, 255, 0.3)'
                  : 'border-top: 1px solid rgb(0, 0, 0, 0.3)'
              "
              >Save</v-btn
              >
            </div>
          </v-menu>

          <v-btn @click="$emit('delete', cardInfo)" icon small>
            <v-icon
                class="flex-grow-1 text-center"
                style="font-size: 12px !important"
            >
              fa-solid fa-trash
            </v-icon>
          </v-btn>
          <!-- <v-spacer></v-spacer> -->
        </v-row>
        <!-- v-if="true" -->
        <v-row
            v-if="loadingData"
            justify="center"
            align="center"
            fill-height
            style="height: 100%"
        >
          <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
              class="mb-4"
          ></v-progress-circular>
        </v-row>
        <v-row
            v-else-if="headers.length < 2 && tableData.length"
            justify="center"
            align="center"
            fill-height
            style="height: calc(100% - 30px)"
        >
          No Symbols Selected
        </v-row>
        <div v-else-if="tableData.length" style="overflow-x: auto">
          <v-data-table
              dense
              :key="rowRenderKey"
              :items-per-page="-1"
              :headers="headers"
              :items="tableData"
              hide-default-footer
              :height="tableHeight * 84 - 84"
              fixed-header
              :mobile-breakpoint="0"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td
                    v-for="(header, i) in headers"
                    :key="header.value"
                    :class="{
                  'primary--text':
                    item[header.value].status === PW_PRICE_STATUSES.INCREASE &&
                    $vuetify.theme.dark,
                  'secondary--text':
                    item[header.value].status === PW_PRICE_STATUSES.INCREASE &&
                    !$vuetify.theme.dark,
                  'red--text text--lighten-3':
                    item[header.value].status === PW_PRICE_STATUSES.DECREASE &&
                    $vuetify.theme.dark,
                  'red--text':
                    item[header.value].status === PW_PRICE_STATUSES.DECREASE &&
                    !$vuetify.theme.dark,
                }"
                    class="live_table_cell mid-item"
                >
                  <v-tooltip
                      :disabled="
                      item.appStatus === 'RUN' || header.value !== 'broker'
                    "
                      content-class="tooltipClass"
                      bottom
                  >
                    <template v-slot:activator="{ on }">
                      <p
                          v-on="on"
                          class="mb-0"
                          :class="{ 'grey--text': item.appStatus !== 'RUN' }"
                      >
                        {{ i == 0 ? item.broker : item[header.value].value }}
                      </p>
                    </template>
                    <span
                    ><v-icon
                        style="font-size: 14px; margin-bottom: 4px"
                        class="mr-1"
                        color="red"
                    >fas fa-exclamation-triangle</v-icon
                    >Application not running
                    </span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-slot:no-data>
              <v-row class="mx-0 fullSize" justify="center">
                <v-col align-self="center">
                  <v-row justify="center">
                    <p style="font-size: 0.875rem">No data available</p>
                  </v-row>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-row
            v-else-if="!tableData.length"
            justify="center"
            align="center"
            fill-height
            style="height: calc(100% - 30px)"
        >
          <p class="grey--text text-center">No data available</p>
        </v-row>
      </div>
    </div>
  </v-card>
</template>

<script>
import { events } from "@/plugins/events";
import { PW_PRICE_STATUSES } from "@/utilities/enums";
// import { ChartsService } from "@/services/ApiService";
// import { findIndex } from "rxjs";

export default {
  name: "LivePricesCard",
  props: {
    // TODO
    // 1. Using Wathcers you can create the rows (data) (since its a row per watcher)
    // 2. Using definitions you can extract all available symbols to create columns (headers)
    // TODO
    // 3. Table updates will be received from event bus which will emit events from app.vue for every new price
    cardInfo: {
      type: Object,
      default: () => {},
    },
    watchers: {
      type: Array,
      default: () => [],
    },
    definitions: {
      type: Array,
      default: () => [],
    },
    tableHeight: {
      type: Number,
      default: 4,
    },
    isPublic: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    // updatingColumns: false,
    // updatingRows: false,
    firstTableUpdateDone: false,
    rowRenderKey: 0,
    watchersMenuItems: [],
    selectedWatchers: [],
    selectedSymbols: [],
    symbolsMenu: false,
    watchersMenu: false,
    allSymbols: [],
    PW_PRICE_STATUSES: PW_PRICE_STATUSES,
    loadingData: false,
    loadingTable: true,
    tableData: null,
    headers: null,
  }),
  mounted() {
    events.$on("pw-live-update", this.handleLiveUpdate);
  },
  methods: {
    reRenderRows() {
      if(this.rowRenderKey < 10) this.rowRenderKey++
      else this.rowRenderKey = 0
    },
    // multiplierChanged(item, multiplier) {
    //   item.multiplier = multiplier;
    // },
    // inputOfMultiplierComponent(ev, item) {
    //   if (!ev) {
    //     item.editingMultiplier = false;
    //   }
    // },
    // showMultipliersList(item) {
    //   let actualItem = this.tableData.find((el) => el.id == item.id);
    //   actualItem.editingMultiplier = true;
    // },
    handleLiveUpdate(payload) {
      let row = this.tableData.find((el) => el.id === payload.identity);
      payload.data.forEach((el) => {
        // If this symbol doesnt have a column then return to avoid any errors
        if (!(typeof row == "object" && row.hasOwnProperty([el.symbol]))) {
          // console.error("Live table error. The table doesn't have the symbol " + el.symbol + " or row : " + payload.identity);
          return;
        }
        // if (!row[el.symbol]) return;

        let status;
        let oldValue = row[el.symbol].value;
        if (oldValue === "-") status = PW_PRICE_STATUSES.INCREASE;
        else if (oldValue === el.points) status = row[el.symbol].status;
        else if (oldValue < el.points) status = PW_PRICE_STATUSES.INCREASE;
        else status = PW_PRICE_STATUSES.DECREASE;

        row[el.symbol] = {
          value: el.points,
          status: status,
          datetime: el.datetime,
        };

        if(!this.firstTableUpdateDone) {
          this.firstTableUpdateDone = true
          this.reRenderRows()
        }

        // row[el.symbol] = el.points;
      });
    },
    getFullIdentity(definition) {
      let stringID = definition.id.toString();
      let numberOfDigits = stringID.length;
      switch (numberOfDigits) {
        case 1:
          stringID = "00" + stringID;
          break;
        case 2:
          stringID = "0" + stringID;
          break;
      }

      return definition.application.code + stringID;
    },
    refreshRows() {
      // TODO
      // 1.
      // - Calculate the rowsToRemove
      // - Remove those rows
      let itemsToRemove = this.tableData.filter((row) => {
        return this.selectedWatchers.every((watcher) => watcher.id !== row.id);
      });

      itemsToRemove.forEach((row) => {
        let index = this.tableData.findIndex((el) => el.broker === row.broker);
        this.tableData.splice(index, 1);
      });
      // let finalData = JSON.parse(JSON.stringify(this.tableData));

      // 2.
      // - Calculate the rowsToAdd
      // - Add those rows
      let itemsToAdd = this.selectedWatchers.filter((watcher) => {
        return this.tableData.every((row) => row.id !== watcher.id);
      });

      itemsToAdd.forEach((watcher) => {
        let row = { id: watcher.id };
        this.headers.forEach((header) => {
          if (header.value === "broker") {
            row[header.value] = watcher.name;
            return;
          }
          row[header.value] = {
            value: "-",
            status: PW_PRICE_STATUSES.NEUTRAL,
            datetime: null,
          };
        });

        row.appStatus = watcher.appStatus;
        this.tableData.push(row);
      });
    },
    updateTableRows() {
      this.selectedWatchers = this.watchersMenuItems.reduce((final, next) => {
        if (next.selected)
          final.push({
            id: next.id,
            name: next.name,
            appStatus: next.appStatus,
          });
        return final;
      }, []);

      if (!this.selectedWatchers.length) {
        this.$notifier.error("Please select at least one watcher");
        return;
      }

      this.$emit(
        "update-table-watchers",
        this.selectedWatchers.map((el) => el.id)
      );

      this.watchersMenu = false;
      
      // // Update the symbols
      // this.allSymbols = this.getAllSymbols(true);

    },
    rerenderTable(modifiedProperty = null) {
      if (modifiedProperty) {
        if (modifiedProperty === "watchers") {
          this.allSymbols = this.getAllSymbols(true);
          this.refreshRows();
        }
        if (modifiedProperty === "symbols") {
          // Updating this.allSymbols so that the symbols menu is up to date with the selected watchers
          this.allSymbols = this.getAllSymbols(true);
          this.refreshHeaders();
        }
      }
      // this.createRows();
    },
    getAllSymbols(useSelectedSymbols = false) {
      // UseSelectedSymbols symbols is used in addSymbolProperties()
      // It is used to add the "selected" property. When useSelectedSymbols = true the "selected" property will
      // depend on the this.selectedSymbols array instead of this.cardInfo.symbols (because cardInfo.symbols is not updated at that point yet)

      // tableWatcherDefinitions are the definitions of watchers of this specific table/card and not generally all watchers
      let tableWatcherDefinitions = this.definitions.filter((el) => {
        let identity = this.getFullIdentity(el);
        return this.cardInfo.watchers.includes(identity);
      });

      let arraysOfSymbols = tableWatcherDefinitions.reduce((final, next) => {
        // Only extract the symbols of running watchers
        if (
          !this.priceGuardEnabled(next.configuration)
          //  ||
          // !this.watcherIsRunning(next)
        )
          return final;

        let symbols = JSON.parse(JSON.stringify(next.configuration.watched_symbols))
        if(symbols.length) {
          if(typeof symbols[0] == "object") {
            
            symbols = symbols.reduce((final, next) => {
              if(next.hasOwnProperty("alias") && next.alias !== "") {
                  final.push(next.alias)
              } else {
                final.push(next.name)
              }
              return final
            }, [])
            
          }
          final.push(symbols);
        }
        return final;
      }, []);

      // Create a new array from array of arrays of strings without duplicates
      let symbols = this.getSingleArray(arraysOfSymbols);
      let finalSymbols = this.addSymbolProperties(symbols, useSelectedSymbols);
      return finalSymbols.sort((a, b) => a.symbol.localeCompare(b.symbol))
    },
    updateTableColumns() {
      // this.updatingColumns = true

      this.selectedSymbols = this.allSymbols.reduce((final, next) => {
        if (next.selected) final.push(next.symbol);
        return final;
      }, []);

      if (!this.selectedSymbols.length) {
        this.$notifier.error("Please select at least one symbol");
        return;
      }

      this.$emit("update-table-symbols", this.selectedSymbols);

      this.symbolsMenu = false;
    },
    addSymbolProperties(symbols, useSelectedSymbols = false) {
      return symbols.map((symbol) => {
        let selected;
        if (useSelectedSymbols)
          selected = this.selectedSymbols.includes(symbol);
        else {
          let symbolProp = this.cardInfo.hasOwnProperty("symbol")
            ? "symbol"
            : "symbols";
          selected = this.cardInfo[symbolProp].includes(symbol);
        }
        return { selected: selected, symbol: symbol };
      });
    },
    getSingleArray(arraysOfSymbols) {
      return [...new Set([...arraysOfSymbols.flat()])];
    },
    priceGuardEnabled(configuration) {
      return (
        // !Analytics means its a native PriceWatcher so obviously PG is enabled
        !configuration.hasOwnProperty("Analytics") ||
        (configuration.hasOwnProperty("PriceGuard") &&
          configuration.PriceGuard.Enabled)
      );
    },
    // watcherIsRunning(definition) {
    //   return this.watchers.some(
    //     (el) =>
    //       el.id == this.getFullIdentity(definition) &&
    //       el.appStatus == "RUN"
    //   );
    // },
    refreshHeaders() {
      // Remove not needed headers from the this.headers
      // Remove the items using splice(0,1) which needs the index of the item
      // How:
      // Create an array itemsToRemove (headers that are not in the new headers array but are in the old one)
      // for each item in itemsToRemove get the index of that item in this.headers and remove it using splice(index,1)

      let itemsToRemove = this.headers.filter(
        (oldHeader) =>
          oldHeader.value !== "broker" &&
          this.selectedSymbols.every((symbol) => symbol !== oldHeader.value)
      );

      itemsToRemove.forEach((item) => {
        let index = this.headers.findIndex((el) => el.value === item.value);
        this.headers.splice(index, 1);
      });

      // Add the missing headers to the this.headers
      // How:
      // Unshift or push each header from the headers array (made above)

      let itemsToAdd = this.selectedSymbols.filter((symbol) => {
        return this.headers.every((header) => header.value !== symbol);
      });

      itemsToAdd.forEach((item) => {
        // Add the new column to the row
        this.tableData.forEach((row) => {
          row[item] = {
            value: "-",
            status: PW_PRICE_STATUSES.NEUTRAL,
            datetime: null,
          };
        });
        // Add the new column to the headers
        this.headers.splice(1, 0, {
          text: item,
          value: item,
          height: "48px",
          sortable: true,
        });
      });

      // TODO
      // When adding each new columns
      // it also must be added as a "-" to each row

      // this.headers = this.allSymbols.map((symbol) => {
      //   let header = getDefaultHeader();
      //   header.text = symbol;
      //   header.value = symbol;
      //   return header;
      // });
      // this.headers.unshift({
      //   text: "Broker",
      //   value: "broker",
      //   width: "220px",
      //   height: "48px",
      // });
    },
    createHeaders() {
      this.headers = [];

      this.allSymbols = this.getAllSymbols();

      this.selectedSymbols = this.allSymbols.reduce((final, next) => {
        if (next.selected) final.push(next.symbol);
        return final;
      }, []);

      this.headers = this.allSymbols.reduce((final, next) => {
        if (!next.selected) return final;
        let header = getDefaultHeader();
        header.text = next.symbol;
        header.value = next.symbol;
        final.push(header);
        return final;
      }, []);
      // this.headers = this.allSymbols.map((symbol) => {
      //   let header = getDefaultHeader();
      //   header.text = symbol;
      //   header.value = symbol;
      //   return header;
      // });
      this.headers.unshift({
        text: "Broker",
        value: "broker",
        width: "250px",
        height: "48px",
      });
    },
    createRows() {
      this.tableData = [];
      // Only include the watchers of this specific live-card
      let watchers = this.watchers.map((watcher) => {
        return {
          appStatus: watcher.appStatus,
          id: watcher.id,
          name: watcher.name,
          selected: this.cardInfo.watchers.includes(watcher.id),
        };
      }, []);

      this.watchersMenuItems = watchers.sort((a, b) => a.name.localeCompare(b.name))

      this.selectedWatchers = this.watchersMenuItems.reduce((final, next) => {
        if (next.selected)
          final.push({
            id: next.id,
            name: next.name,
            appStatus: next.appStatus,
          });
        return final;
      }, []);

      watchers = watchers.filter((watcher) =>
        this.cardInfo.watchers.includes(watcher.id)
      );
      // let watchers = this.watchers.filter((watcher) =>
      //   this.cardInfo.watchers.includes(watcher.id)
      // );
      watchers.forEach((watcher) => {
        let row = { id: watcher.id };
        this.headers.forEach((header) => {
          if (header.value === "broker") {
            row[header.value] = watcher.name;
            return;
          }
          row[header.value] = {
            value: "-",
            status: PW_PRICE_STATUSES.NEUTRAL,
            datetime: null,
          };
        });
        row.appStatus = watcher.appStatus;
        this.tableData.push(row);
      });
      this.loadingTable = false;
    },
  },
  created() {
    this.createHeaders();
    this.createRows();
  },
  beforeDestroy() {
    events.$off("pw-live-update", this.handleLiveUpdate);
  },
  watch: {
    symbolsMenu(v) {
      if (!v) {
        this.allSymbols = this.getAllSymbols(true);
      }
    },
  },
};
function getDefaultHeader() {
  return { text: "", value: "", height: "48px", sortable: true };
}
</script>
<style>
.live_table_cell td {
  height: 32px !important;
  max-height: 32px !important;
  min-height: 32px !important;
}

.theme--dark .multiplier-list .v-list-item + .v-list-item {
  border-top: 1px solid rgb(255, 255, 255, 0.2);
}

.theme--light .multiplier-list .v-list-item + .v-list-item {
  border-top: 1px solid rgb(0, 0, 0, 0.2);
}
</style>
